// import { rem } from 'polished'
import * as React from 'react'
// import styled from 'styled-components'

import PriceDetails from 'tripPlanner/components/ItemOfferPrice/PriceDetails'

import getValueOffPercent from 'lib/offer/getValueOffPercent'

interface Props {
  depositComponent: React.ReactNode
  pkg: App.Package
  currencyCode: string
}

function TourOfferCardPriceDetails({
  pkg,
  depositComponent,
  currencyCode,
}: Props) {
  const shouldShowDiscount = pkg?.shouldDisplayValue && pkg.value > pkg.price
  const discount = getValueOffPercent(pkg.value, pkg.price)
  const priceLabel = `${pkg.durationLabel.toLocaleLowerCase()} from`
  return (
    <PriceDetails
      price={pkg.price}
      discount={discount}
      currencyCode={currencyCode}
      priceLabel={priceLabel}
      totalLabel="/person"
      discountDisplayType={shouldShowDiscount ? 'badge' : 'none'}
      roomOccupancy={pkg.roomOccupancy}
      depositComponent={depositComponent}
    />
  )
}

export default TourOfferCardPriceDetails
